exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".swiper-container[data-v-5691b2cc]{height:40vh;width:100%}.slide-img[data-v-5691b2cc]{width:100%;height:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-5691b2cc&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/CustomerService.vue
// module id = 957
// module chunks = 0